import { render, staticRenderFns } from "./StorefrontSubsidy.vue?vue&type=template&id=6d8fc8e5&scoped=true"
import script from "./StorefrontSubsidy.vue?vue&type=script&lang=js"
export * from "./StorefrontSubsidy.vue?vue&type=script&lang=js"
import style0 from "./StorefrontSubsidy.vue?vue&type=style&index=0&id=6d8fc8e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8fc8e5",
  null
  
)

export default component.exports